import React, { FC } from 'react'
import Main from './Components/Main';
import PublicLayout from '@/Components/layouts/ResponsivePublicLayout';

export enum ProfilePageModules {
  default = 'default',
  wallet = 'wallet',
  my_posts = 'my_posts',
  archived_chats = 'archived_chats',
  user_settings = 'user_settings',
  notifications = 'notifications',
  language = 'language',
  privacy = 'privacy',
  service = 'service'
}

interface IProfilePageProps {
  moduleName: ProfilePageModules;
};

const ProfilePage: FC<IProfilePageProps> = ({ moduleName }) => {
  
  return (
    <PublicLayout visibleMobileNavbar>
      <Main moduleName={moduleName} />
    </PublicLayout>
  )
}

export default ProfilePage;
